export const normalizeHtmlContent = (content?: string | null): string => {
  const trimmed = (content ?? '').trim();

  if (!trimmed) {
    return '';
  }

  const normalized = trimmed
    // HTML entities for empty content
    .replaceAll('&nbsp;', ' ')
    .replaceAll('&ZeroWidthSpace;', ' ')
    .replaceAll('\u00A0', ' ') // Non-breaking space
    .replaceAll('\u200B', ' ') // Zero-width space
    .replaceAll('\u200C', ' ') // Zero-width non-joiner
    .replaceAll('\u200D', ' ') // Zero-width joiner
    .replaceAll('\uFEFF', ' '); // Zero-width no-break space (BOM)
  // // HTML tags - line breaks
  // .replaceAll('<br>', '\n')
  // .replaceAll('<br/>', '\n')
  // .replaceAll('<br />', '\n')
  // // HTML tags - paragraphs
  // .replaceAll('<p></p>', '\n')
  // .replaceAll('<p><br></p>', '\n')
  // .replaceAll('<p><br/></p>', '\n')
  // .replaceAll('<p><br /></p>', '\n')
  // // HTML tags - divs
  // .replaceAll('<div></div>', '\n')
  // .replaceAll('<div><br></div>', '\n')
  // .replaceAll('<div><br/></div>', '\n')
  // .replaceAll('<div><br /></div>', '\n')
  // // HTML tags - spans
  // .replaceAll('<span></span>', '')
  // // Empty paragraphs with any whitespace
  // .replaceAll(/<p>\s*<\/p>/gi, '\n')
  // .replaceAll(/<p>\s*<br\s*\/?>\s*<\/p>/gi, '\n')
  // // Empty divs with any whitespace
  // .replaceAll(/<div>\s*<\/div>/gi, '\n')
  // .replaceAll(/<div>\s*<br\s*\/?>\s*<\/div>/gi, '\n')
  // // Empty spans with any whitespace
  // .replaceAll(/<span>\s*<\/span>/gi, '')
  // // Line breaks at start/end
  // .replaceAll(/<br\s*\/?>\s*$/gi, '\n')
  // .replaceAll(/^\s*<br\s*\/?>/gi, '\n')
  // // Multiple consecutive line breaks
  // .replaceAll(/(<br\s*\/?>){2,}/gi, '\n\n');

  return normalized.trim() || '';
};
